export default {
    dailypassList: []
};



// WEBPACK FOOTER //
// ./src/store/modules/dailypass/state.js